import { BackendAxiosError, MediaType } from '@yaotai/common-utils';
import { getCenterCurrentRedirectLoginUrl } from './common';

export const getCenterUnAuthCb =
  ({ mediaType }: { mediaType?: MediaType } = {}) =>
  (error: BackendAxiosError, msg: string) => {
    window.location.href = getCenterCurrentRedirectLoginUrl();
  };
